import compact from 'lodash/compact';

interface IUserNameDate {
  firstName: string;
  lastName: string;
  middleName?: string;
}

// Получение ФИО пользователя
export const getUserFullname = ({ firstName, lastName, middleName }: IUserNameDate) => (
  compact([lastName, firstName, middleName]).join(' ')
);

// Получение ФИО пользователя с инициалами и фамилией
export const getUserFullnameShortened = ({ firstName, lastName, middleName }: IUserNameDate) => (
  `${lastName} ${compact([firstName[0], middleName?.[0]]).join('. ')}.`
);
